import React from 'react';

import { LazyNBMPerformanceReportPage } from '@confluence/nbm-performance-report/entry-points/LazyNBMPerformanceReportPage.ts';
import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';

export const AdminNBMPerformanceReportScanRoute = () => <LazyNBMPerformanceReportPage />;

AdminNBMPerformanceReportScanRoute.NAVIGATION_PARAMS = () => ({
	Screen: {
		screenEvent: { name: 'adminNBMPerformanceReportScan' },
	},
	MainLayout: {
		navView: ADMIN_HOME_ID,
	},
});
